"use client";

import { useEffect, useLayoutEffect, useState } from "react";
import CodingIntro from "@/components/CodingIntro";
import Cookies from "js-cookie";

// 클라이언트는 paint 전(useLayoutEffect)에 재방문 판정을 적용해 "정적 전체 노출" 전환 시 깜빡임을 없앤다.
// 서버에서는 layout effect 가 의미 없으므로 useEffect 로 대체(no-op).
const useIsomorphicLayoutEffect =
  typeof window !== "undefined" ? useLayoutEffect : useEffect;

/**
 * 코딩 공부법 인트로 게이팅 (JCG-2099).
 *
 * - 첫 방문(쿠키 없음): 타자기 애니메이션으로 펼친다. 본 즉시 쿠키 기록.
 * - 재방문(쿠키 있음): 애니메이션 없이 전체 내용이 그대로 보이는 정적 상태로 노출.
 * 인트로는 어느 경우에도 숨겨지지 않고 항상 보여진다(숨기기/다시 보기 버튼 없음).
 *
 * SSR·하이드레이션 기준값은 revealed=false(첫 방문 애니메이션과 동일 마크업)라 mismatch 없음.
 * 재방문 판정은 paint 전에 revealed=true 로 올려 애니메이션 시작 프레임 없이 곧장 전체 노출한다.
 */
export default function CodingIntroClient() {
  const [revealed, setRevealed] = useState(false);

  useIsomorphicLayoutEffect(() => {
    const seen = Boolean(Cookies.get("codingIntroShown"));
    if (seen) {
      setRevealed(true);
    } else {
      Cookies.set("codingIntroShown", "true", { expires: 365 });
    }
  }, []);

  return <CodingIntro revealed={revealed} />;
}
